(function(){
     'use strict';

     angular
        .module('app')
        .factory('UserService', UserService);

    UserService.$inject = ['$http'];

    function UserService($http){

        var service= {
           Recuperarpassword:Recuperarpassword,
           Changepassword:Changepassword,
           Login:Login,
           anoFacturas:anoFacturas,
           Delegados:Delegados,
        };

        function Recuperarpassword(vm){
            var config = {
                headers : {}
            } 
            return $http.post('/ajax/recoverypassword', {
                  RecoveryForm:{
                      username:vm.username,
                      msgemail:vm.msgemail
                  }
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function Changepassword(vm){
            var config = {
                headers : {}
            } 
            return $http.post('/ajax/recoverypassword', {
                  RecoveryForm:{

                      password:vm.password,
                      password_rep:vm.password_rep,
                      token:vm.token
                  },
                  action:"change"
             } , config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function Login(vm){
            var config = {
                headers : {}
            }
            return $http.post(
                '/ajax/login',{
                  LoginForm:{username:vm.username, password:vm.password, name:vm.name}
                }
                ,config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
            

        };

        function anoFacturas(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            $http.get('/ajax/facturas', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function Delegados(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            $http.get('/ajax/delegados', { params : { filtros : JSON.stringify(filtros) } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        return service;

    }

})();